import CryptoJS from "crypto-js";

const secretKey = "redux-central-system-of-otb"; // Use a strong, unique key

// secureLocalStorage.setItem("acessTokens", JSON.stringify(acessTokens));

const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString); // Convert string back to object/array
};

const encryptData = (data) => {
  const stringData = JSON.stringify(data); // Convert object/array to string
  return CryptoJS.AES.encrypt(stringData, secretKey).toString();
};
let userInfo = localStorage.getItem("userInfo");
let userData = userInfo ? decryptData(userInfo) : null;

const initialState = {
  user: userData ? userData : null,
};

const reducer = (state = initialState, action) => {
  if (action.type === "userLogin") {
    const user = encryptData(action.payload);

    localStorage.setItem("userInfo", user);

    return {
      ...state,
      user: action.payload,
    };
  } else if (action.type === "userLogOut") {
    localStorage.removeItem("userInfo");

    return {
      ...state,
      user: null,
    };
  } else {
    return state;
  }
};
export default reducer;
